import { Routes } from '@angular/router';
import { PageLayout } from 'src/app/layout/layout.enum';

const defaultPageOptions = {
  pageProvider: '',
  name: '',
  type: '',
  pageType: PageLayout.Default,
  extraData: {
    title: '',
    id: '',
    path: '',
    components: {
      global: false,
      advantage: false,
      footer: true,
      header: false,
      globalTimer: false,
      newsletter: false,
      breadcrumbs: false,
      customComponents: null,
    },
  },
};

export const RecommendedBrushRoutes: Routes = [
  {
    path: 'recommendedbrushes',
    loadComponent: () => import('./recommended-brush.component').then((r) => r.AppRecommendedBrushComponent),
    data: {
      page: defaultPageOptions,
    },
  },
];
